// purchases-misc-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1p.docs.movedToTrash': 'Documento movido a la papelera.',
  'r1p.docs.moveFailed': 'No se pudo mover el documento.',
  'r1p.docs.restored': 'Documento restaurado.',
  'r1p.docs.restoreFailed': 'No se pudo restaurar el documento.',
  'r1p.docs.confirmDeleteOne': '¿Eliminar el documento de forma permanente?',
  'r1p.docs.confirmDeleteMany': '¿Eliminar los documentos seleccionados de forma permanente?',
  'r1p.docs.deletedPermanently': 'Documento eliminado de forma permanente.',
  'r1p.docs.deleteFailed': 'No se pudo eliminar el documento.',
  'r1p.selectedCount': '{count} seleccionados',
  'r1p.sale.backendNotReady': 'El almacenamiento del backend no está listo.',
  'r1p.sale.lineRequired': 'Añade al menos una línea de venta.',
  'r1p.manual.noAccountMatch': 'Ninguna cuenta coincide con «{query}».',
  'r1p.picker.searchPlaceholder': 'Busca por nombre, número o p. ej. 4300',
  'r1p.picker.favorite': 'Favorito',
});
